import { Box } from "@mui/material";
import { CircularProgress } from "@mui/material";

export const LoadingState = () => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    minHeight="500px"
  >
    <CircularProgress />
  </Box>
);
